import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const TickCircleFilled: FC<IconProps> = (props) => (
  <Icon {...props} title={props.title || 'Tick icon'}>
    <path
      fill="currentColor"
      d="M3 16a13 13 0 1 1 26 0 13 13 0 0 1-26 0Zm17.81-2.42a1 1 0 1 0-1.62-1.16l-4.32 6.04-2.16-2.17a1 1 0 0 0-1.42 1.42l3 3a1 1 0 0 0 1.52-.13l5-7Z"
    />
  </Icon>
);
